import React from 'react';
import { clientNavItems } from '../../../config/clientNav';

interface MobileBottomNavProps {
  currentView: string;
  onNavigate: (view: string) => void;
}

export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ currentView, onNavigate }) => {
  const items = clientNavItems.filter((item) => item.bottomNav && item.enabled);

  return (
    <nav className="mc-bottom-nav">
      {items.map((item) => {
        const Icon = item.icon;
        const active = item.view === currentView;
        return (
          <button
            key={item.id}
            className={`mc-bottom-nav-item ${active ? 'active' : ''}`}
            onClick={() => onNavigate(item.view)}
          >
            <Icon size={22} />
            <span className="mc-bottom-nav-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
